/* ==========================================================================
   SECTOR EXPERTISE TABS MODULE (WITH AUTO-ROLL & INTERACTIVE PAUSE)
   ========================================================================== */

const sectorData = {
  health: {
    title: "Health Systems Strengthening & Information Management",
    summary: "Supporting public health governance, medical logistics, health management information systems (HMIS), and institutional capacity building across East Africa.",
    image: "/images/health-systems.jpg",
    tags: ["HMIS Data Systems", "Public Health Governance", "Supply Chain Optimization", "Health Metrics & M&E"]
  },
  agriculture: {
    title: "Agri-Business & Watershed Management Advisory",
    summary: "Delivering sustainable climate-smart agriculture solutions, technical micro-enterprise training, landscape management, and value chain development.",
    image: "/images/agriculture-advisory.jpg",
    tags: ["Climate-Smart Ag", "Watershed Mgmt", "Micro Enterprise Assistance", "SME Agri-Finance"]
  },
  gis: {
    title: "Spatial Analysis & Technical Survey Services",
    summary: "Providing high-precision geospatial surveys, satellite remote sensing, boundary mapping, and urban/rural infrastructure spatial analysis.",
    image: "/images/gis-spatial.jpg",
    tags: ["GIS Mapping", "Geospatial Surveys", "Satellite Analysis", "Infrastructure Planning"]
  },
  governance: {
    title: "Governance, Institutional Oversight & PFM",
    summary: "Assisting government agencies and institutional bodies in public financial management, policy design, compliance frameworks, and organizational restructuring.",
    image: "/images/hero-consulting.jpg",
    tags: ["PFM Advisory", "Institutional Oversight", "Policy Frameworks", "Compliance & Risk"]
  },
  trade: {
    title: "Trade Facilitation & Border-Post Management",
    summary: "Optimizing cross-border logistics, regional trade corridor efficiency, custom process digitization, and economic development strategies.",
    image: "/images/gis-spatial.jpg",
    tags: ["Border-Post Systems", "Trade Corridor Logistics", "Customs Digitization", "Regional Trade"]
  },
  smes: {
    title: "SME & Micro-Enterprise Technical Assistance",
    summary: "Empowering African small and medium businesses with strategic innovation, financial management tools, and performance optimization.",
    image: "/images/hero-consulting.jpg",
    tags: ["Business Model Design", "Grant Mgmt", "Performance Optimization", "Financial Advisory"]
  }
};

const DURATION_MS = 5000; // 5 seconds per sector tab

export function initSectorTabs() {
  const tabs = Array.from(document.querySelectorAll('.sector-tab'));
  const titleEl = document.getElementById('sector-title');
  const summaryEl = document.getElementById('sector-summary');
  const imgEl = document.getElementById('sector-img');
  const tagsContainer = document.getElementById('sector-tags-container');
  const sectionWrapper = document.getElementById('expertise');

  if (!tabs.length || !titleEl) return;

  let currentIndex = 0;
  let autoTimer = null;
  let isUserHovered = false;

  function activateTab(index) {
    currentIndex = index;
    const activeTab = tabs[index];
    if (!activeTab) return;

    // Update active tab classes
    tabs.forEach(t => t.classList.remove('active'));
    activeTab.classList.add('active');

    const sectorKey = activeTab.dataset.sector;
    const data = sectorData[sectorKey];

    if (data) {
      const card = document.querySelector('.sector-display-card');
      if (card) {
        card.style.opacity = '0.4';
        card.style.transform = 'translateY(4px)';
      }

      setTimeout(() => {
        titleEl.textContent = data.title;
        summaryEl.textContent = data.summary;
        if (imgEl) imgEl.src = data.image;

        if (tagsContainer) {
          tagsContainer.innerHTML = data.tags
            .map(tag => `<span class="pill-badge teal">${tag}</span>`)
            .join('');
        }

        if (card) {
          card.style.opacity = '1';
          card.style.transform = 'translateY(0)';
        }
      }, 160);
    }
  }

  function nextTab() {
    const nextIndex = (currentIndex + 1) % tabs.length;
    activateTab(nextIndex);
  }

  function startAutoRoll() {
    stopAutoRoll();
    autoTimer = setInterval(() => {
      if (!isUserHovered) {
        nextTab();
      }
    }, DURATION_MS);
  }

  function stopAutoRoll() {
    if (autoTimer) {
      clearInterval(autoTimer);
      autoTimer = null;
    }
  }

  // Handle Tab Click by User
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      activateTab(index);
      // Restart rotation timer after explicit user click
      startAutoRoll();
    });
  });

  // Pause auto-roll when user interacts with section (Hover or Focus)
  if (sectionWrapper) {
    sectionWrapper.addEventListener('mouseenter', () => {
      isUserHovered = true;
      document.body.classList.add('sector-tabs-paused');
    });

    sectionWrapper.addEventListener('mouseleave', () => {
      isUserHovered = false;
      document.body.classList.remove('sector-tabs-paused');
      startAutoRoll();
    });

    sectionWrapper.addEventListener('touchstart', () => {
      isUserHovered = true;
    }, { passive: true });
  }

  // Initialize first tab & start auto-rotation
  activateTab(0);
  startAutoRoll();
}
